import { colors } from '@constants/colors';
import { SwiperScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = (isSelectedEvent: boolean) => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const { backgroundColor, backgroundColorHover } = appTheme.submitButton;

  return {
    root: {
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        width: '100%',
      },
    },
    card: {
      boxShadow: 'none',
    },
    avatarPicContainer: {
      position: 'relative',
      overflow: 'hidden',
      height: '146px',
      width: '146px',
      cursor: 'pointer',
      borderRadius: '16px',
      boxSizing: 'border-box',
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        width: 'calc(100% - 4px)',
        aspectRatio: '1/1',
        height: 'calc(100% - 4px)',
      },
      [`@media (hover: hover)`]: {
        '&:hover': {
          border: `2px solid ${backgroundColorHover}`,
        },
      },
      border: isSelectedEvent
        ? `2px solid ${backgroundColor}`
        : `2px solid ${colors.grey_100}`,
    },
    avatarPic: {
      position: 'absolute',
      width: '500%',
      top: '50%',
      right: '55%',
      transform: 'translate(50%, -20%)',
    },
    emptyAvtarPic: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    actions: {
      display: 'flex',
      padding: 0,
      marginTop: '10px',
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        '&:last-child': {
          paddingBottom: '40px',
        },
      },
    },
    action: (canOperateAction = true) => ({
      cursor: canOperateAction ? 'pointer' : 'default',
      border: `1px solid ${colors.grey_100}`,
      padding: '8px',
      borderRadius: '24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '10px',
      opacity: canOperateAction ? 1 : 0.5,
    }),
    actionIcon: {
      fill: colors.grey_400,
      width: '12px',
      height: '12px',
    },
  };
};
